import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () => ({
    root: {
      position: 'static', // rewrite from 'relative' because it messes with initial popper-js positioning of the menu element
    },
    title: {},
  }),
  { name: 'BlockImageOverlay' }
);
